import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import FloatingInput from './FloatingInput';
// import FloatingSelect from './FloatingSelect'; 
import hiro from '../../assets/images/Logo.png';
import group208 from '../../assets/images/Group 208.png';
import reda from '../../assets/images/lgD.png';
import rectangle15 from '../../assets/images/Rectangle 15.png';
import { Modal, Button } from 'react-bootstrap';
import { FaArrowRight, FaLocationDot } from "react-icons/fa6";
import './admin.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import api from '../../service/caller';

import logo from '../../assets/images/Logo.png';
import FloatingSelect from './FloatingSelect'; // Importation de FloatingSelect


const Admin = () => {
  const location = useLocation();
  const formData = location.state;
  const navigate = useNavigate();

  // Add new state for title and civility
  const [adminLastName, setAdminLastName] = useState('');
  const [clinicDatas, setClinicDatas] = useState('');
  const [adminFirstName, setAdminFirstName] = useState('');
  const [adminUsername, setUsername] = useState('');
  const [civility, setCivility] = useState('');  // New state
  // const [title, setTitle] = useState('');  // New state
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmPassword] = useState('');
  const [address, setAddress] = useState('');
  const [tel1, setTel1] = useState('');
  const [tel2, setTel2] = useState('');
  const [terms_and_conditions, setTerms_and_conditions] = useState('');
  const [errors, setErrors] = useState({});
  const [title, setTitle] = useState('');  // New state

  const validateForm = () => {
    const newErrors = {};
    const phoneRegex = /^[+0-9]+$/; // Accepte uniquement les chiffres et le signe +

    if (!formData?.clinicName || !formData?.selectedCountry || !formData?.selectedCity || !formData?.selectedDepartment || !formData?.telephone1 || !formData?.telephone2) {
      newErrors.clinicDatas = "Please check the clinic datas !";
      toast.error(`Please check the clinic datas !`);
      const timer = setTimeout(() => {
        navigate('/clientSignUp'); // Remplace '/destination' par l'URL de destination
      }, 3500); // 2000 ms = 2s 
    }

    if (!adminLastName) newErrors.adminLastName = "Admin Last name is required";
    if (!adminFirstName) newErrors.adminFirstName = "Admin First name is required";
    if (!adminUsername) newErrors.adminUsername = "Admin Username is required";
    if (!civility) newErrors.civility = "Civility is required";
    // if (!title) newErrors.title = "Title/Specialty is required";
    if (!email) newErrors.email = "Email is required";
    if (!password) newErrors.password = "Password is required";
    if (!confirmpassword) newErrors.confirmpassword = "Confirm Password is required";
    if (password && confirmpassword && password !== confirmpassword) {
      newErrors.confirmpassword = "Passwords do not match";
    }
    // if (!address) newErrors.address = "Address is required";
    if (!tel1) {
      newErrors.tel1 = "telephone 1 is required";
    } else if (!phoneRegex.test(tel1)) {
      newErrors.tel1 = "telephone 1 must contain only numbers and +";
    }
    if (!tel2) {
      newErrors.tel2 = "telephone 2 is required";
    } else if (!phoneRegex.test(tel2)) {
      newErrors.tel2 = "telephone 2 must contain only numbers and +";
    }

    if (!terms_and_conditions) newErrors.terms_and_conditions = "You must agree to the terms and conditions";
    if (!title) newErrors.title = "Title/Specialty is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const newFormData = new FormData();

      // Assure-toi que 'terms_and_conditions' est bien un booléen
      newFormData.append("terms_and_conditions", terms_and_conditions ? "true" : "false");

      // Ajouter les autres champs texte
      const formFields = {
        hospital_name: formData.clinicName,
        hospital_country: formData.selectedCountry,
        hospital_city: formData.selectedCity,
        hospital_state_province: formData.selectedDepartment,
        hospital_phone: formData.telephone1,
        hospital_phone2: formData.telephone2,
        hospital_currency: formData.currency,
        lastname: adminLastName,
        firstname: adminFirstName,
        username: adminUsername,
        civility: civility,
        title: title,
        email: email,
        password: password,
        address: formData.clinicAddress,
        phone: tel1,
        phone2: tel2,
        picture: formData.pictureFile
      };

      // Ajoute tous les autres champs texte à FormData
      Object.entries(formFields).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          newFormData.append(key, value);
        }
      });

      // Ajouter le logo à FormData si un fichier est présent
      // if (formData.picture && formData.picture instanceof File) {
      //   newFormData.append("picture", formData.picture);
      // }

      // Envoi de la requête POST avec FormData
      try {
        const response = await api.post('api/register', newFormData, { headers: { 'Content-Type': 'multipart/form-data' } });
        toast.success("Registration successful!");
        localStorage.setItem("access_token", response.data.token);

        const serializableData = Object.fromEntries(newFormData.entries());
        navigate('/otp', { state: serializableData, other: response.data });
      } catch (error) {
        console.error('Error:', error.response?.data?.message);
        const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
        toast.error(`Error: ${errorMessage}. Please try again.`);
        console.log(`Error: ${errorMessage}. Please try again.`);
      }
    }
  };



  return (
    <div className="admin-container">
      <ToastContainer />
      <div className="admin-signup-section ps-md-5 ps-1">
        <div className="admin-logo">MED<span className='louange'>TINZ</span></div>
        <h2 className="admin-title">Create an account</h2>
        <div className="admin-login-link">
          Already have an account?
          <a href="/clientlogin" className="admin-login-link-text">Log in</a>
        </div>
        <div className="mb-2">
          <p className="inline-text">Administrator's details <span className="hr-container"><hr className='julio' /></span></p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="container-fluid">
            <div className="row g-3">
              <div className="col-md-6">
                <FloatingInput
                  label="Admin's Last Name"
                  value={adminLastName}
                  onChange={(e) => setAdminLastName(e.target.value)}
                  className="w-100"
                />
                {errors.adminLastName && <span className="error text-danger">{errors.adminLastName}</span>}
              </div>
              <div className="col-md-6">
                <FloatingInput
                  label="Admin's First Name"
                  value={adminFirstName}
                  onChange={(e) => setAdminFirstName(e.target.value)}
                  className="w-100"
                />
                {errors.adminFirstName && <span className="error text-danger">{errors.adminFirstName}</span>}
              </div>
              <div className="col-12">
                <FloatingInput
                  label="Admin's Username"
                  value={adminUsername}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-100"
                />
                {errors.adminUsername && <span className="error text-danger">{errors.adminUsername}</span>}
              </div>
              <div className="col-md-4">
                <FloatingSelect
                  label="Sexe"
                  value={civility}
                  onChange={(e) => setCivility(e.target.value)}
                  options={[
                    { value: 'Male', label: 'Male' },
                    { value: 'Female', label: 'Female' }
                  ]}
                  className="w-100"
                />
                {errors.civility && <span className="error text-danger">{errors.civility}</span>}
              </div>
              <div className="col-md-8">
                <FloatingInput
                  label="Title/Position"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Specialist / Doctor"
                  className="w-100"
                />
                {errors.title && <span className="error text-danger">{errors.title}</span>}
              </div>

              {/* Rest of the form remains the same */}
              <div className="col-md-12 mb-2">
                <FloatingInput
                  label="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-100"
                />
                {errors.email && <span className="error text-danger">{errors.email}</span>}
              </div>
            </div>

            <div className="d-flex justify-content-between mb-3 mt-2 phonefield">
              <div className="form-floating mb-3 flex-fill me-2">
                <PhoneInput
                  country={'bj'}
                  value={tel1}
                  onChange={(phone) => setTel1(phone)}
                  inputClass="form-control geste w-100"
                  placeholder="Telephone 1"
                />
                {errors.tel1 && <span className="error">{errors.tel1}</span>}
              </div>
              <div className="form-floating mb-3 flex-fill ms-2">
                <PhoneInput
                  country={'bj'}
                  value={tel2}
                  onChange={(phone) => setTel2(phone)}
                  inputClass="form-control geste w-100"
                  placeholder="Telephone 2"
                />
                {errors.tel2 && <span className="error">{errors.tel2}</span>}
              </div>
            </div>

            <div className="row g-2 mt-1 mb-2">
              <div className="col-md-6">
                <FloatingInput
                  label="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-100"
                />
                {errors.password && <span className="error text-danger">{errors.password}</span>}
              </div>
              <div className="col-md-6">
                <FloatingInput
                  label="Confirm Password"
                  type="password"
                  value={confirmpassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="w-100"
                />
                {errors.confirmpassword && <span className="error text-danger">{errors.confirmpassword}</span>}
              </div>
              <div className="col-12">
                <p className="text-warning mb-3">Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one digit, and one special character.</p>
              </div>
            </div>
          </div>
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="checkbox"
              className="checkbox-black-focus"
              checked={terms_and_conditions}
              onChange={(e) => setTerms_and_conditions(e.target.checked)}
            />
            <label htmlFor="checkbox" className="checkbox-label">
              Agree to our <a href="#" className="link">Terms of use</a> and <a href="#" className="link"> Privacy Policy</a>.
            </label>
            {errors.terms_and_conditions && <span className="error">{errors.terms_and_conditions}</span>}
          </div>
          <div className='mt-4'>
            <button type="submit" className="btn btn-vtn py-3" style={{ background: '#28A745', width: '100%', color: 'white', fontWeight: '600', fontSize: '20px' }}>Continue <FaArrowRight /></button>
          </div>
          {/* <p className='mt-2'>© 2024 | Développé par ITTIQ</p> */}
        </form>
      </div>
      <div className="admin-preview-section">
        <div className="" >
          <img src={reda} alt="reda" className="admin-preview-image" />
          <div className="into mt-4">
            <div className="admin-preview-text">
              Manage your hospital with <span className="admin-highlight">ease</span> now..
            </div>
            <img src={rectangle15} alt="Group 208" className="admin-morije" /> 
          </div>
        </div>
      </div>
      <div className="admin-footer">
        © 2024 | Développé par ITTIQ
      </div>
    </div >
  );
};

export default Admin;